<template>
  <div class="app-container">
    <div class="index-tree-box">
      <type-tree ref="type_tree" @on-select="onSelect" @title-click="titleClick" />
      <div class="right-box">
        <list ref="list" @selRowData="onSelRowData" @table-data-ready="handleTableDataReady">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" @click="onbatchPrint" icon="el-icon-plus">打印条码</el-button>
            <el-button type="success" plain @click="onImprot">导入</el-button>
            <el-button type="success" @click="onExport">导出</el-button>
            <el-button type="primary" :disabled="!select.Id" @click="create" icon="el-icon-plus">添加</el-button>
            <el-button type="danger" @click="delRows">删除</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button type="warning" @click="openAddUsers" :disabled="!hasCheckedRows">批量添加大屏用户</el-button>
            <el-button type="warning" plain @click="openRemoveUsers" :disabled="!hasCheckedRows">批量删除大屏用户</el-button>
          </template>
          <template slot="column" v-if="$permission.canWrite()">
            <el-table-column label="操作" fixed="right" align="center" width="160">
              <template slot-scope="{row}">
                <el-button type="text" @click="edit(row)">编辑</el-button>
                <el-button type="text" @click="showDetail(row)" v-if="row.EquipmentTypeId==6">查看设备数据</el-button>
              <!--  <el-button type="text" @click="onPrint(row)">打印</el-button>-->
              </template>
            </el-table-column>
          </template>
        </list>
      </div>
    </div>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <import-dialog ref="importDialog" @upload-success="reload" />
    <screen-user-select-dialog ref="userSelectDialog" @confirm="handleUserSelect" />
  </div>
</template>

<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/facility/manage/list";
import editDialog from "@/components/facility/manage/editDialog";
import typeTree from "@/components/facility/manage/type/tree";
import importDialog from "@/components/facility/manage/importDialog";
import screenUserSelectDialog from "@/components/facility/manage/screenUserSelectDialog";

export default {
  name: "manage",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    typeTree,
    importDialog,
    screenUserSelectDialog,
  },
  data() {
    return {
      api: require("@/api/ba/equipment").default,
      screenUserApi: require("@/api/ba/equipmentScreenUser").default,
      select: {
        Id: null,
        Name: "",
      },
      selData: [],
      equipmentWithUsers: [], // 设备及用户列表
    };
  },
  computed: {
    hasCheckedRows() {
      return this.selData && this.selData.length > 0;
    }
  },
  mounted() {
    this.$refs.type_tree.getData();
    // 加载设备和大屏用户列表
    //this.loadEquipmentWithUsers();
  },
  methods: {
    showDetail(row){
      this.$router.push({ name: 'equipmentList', params: {mode:"details", data:row } })
    },
    onImprot() {
      this.$refs.importDialog.open();
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
    onSelect(data) {
      console.log("onSelect", data);
      this.select.Id = data.ClassId;
      this.select.Name = data.ClassName;
      this.$refs.list.getData({ IdChain: data.IdChain });
      // this.reload();
    },
    titleClick() {
      this.select.Id = null;
      this.select.Name = "";
      this.$refs.list.getData({ IdChain: null });
    },
    create() {
      this.$refs.editDialog.openCreate({
        ClassId: this.select.Id,
        ClassName: this.select.Name,
      });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.EquipmentId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },

    onSelRowData(data){
      console.log("onSelRowData", data);
      this.selData = data
    },
    onPrint(row) {
      let ids = [row.EquipmentId]; // 创建包含单个ID的数组
      this.openPrintPage(ids);
    },
    onbatchPrint() {
      let ids = this.selData.map(item => item.EquipmentId); // 获取多个ID组成的数组
      this.openPrintPage(ids);
    },
    openPrintPage(ids) {
      let newpage = this.$router.resolve({
        path: '/facilityPrint',
        query: {
          ids: JSON.stringify(ids) // 序列化数组为字符串
        }
      });
      window.open(newpage.href, '_blank');
    },

    // 加载设备及大屏用户列表
    loadEquipmentWithUsers() {
      this.screenUserApi.getEquipmentListWithUsers().then(res => {
        if (res.Code == 0) {
          this.equipmentWithUsers = res.Data;
        }
      });
    },

    // 表格数据加载完成后的处理
    handleTableDataReady(tableData) {
      // 将大屏用户信息合并到表格数据中
      /*
      if (this.equipmentWithUsers && this.equipmentWithUsers.length > 0) {
        tableData.forEach(row => {
          const equipment = this.equipmentWithUsers.find(e => e.EquipmentId === row.EquipmentId);
          if (equipment) {
            this.$set(row, 'ScreenUserNames', equipment.ScreenUserNames);
          } else {
            this.$set(row, 'ScreenUserNames', '');
          }
        });
      }
      */
      console.log('表格数据已加载:', tableData.length);
    },

    // 打开添加用户弹窗
    openAddUsers() {
      if (!this.hasCheckedRows) {
        this.$message.warning("请先选择设备");
        return;
      }
      // 获取这些设备已经关联的用户
      const equipmentIds = this.selData.map(item => item.EquipmentId);
      this.getExistingUsers(equipmentIds).then(existingUsers => {
        this.$refs.userSelectDialog.open("add", existingUsers);
      });
    },

    // 打开删除用户弹窗
    openRemoveUsers() {
      if (!this.hasCheckedRows) {
        this.$message.warning("请先选择设备");
        return;
      }
      // 获取这些设备已经关联的用户
      const equipmentIds = this.selData.map(item => item.EquipmentId);
      this.getExistingUsers(equipmentIds).then(existingUsers => {
        this.$refs.userSelectDialog.open("remove", existingUsers);
      });
    },

    // 获取已关联的用户
    getExistingUsers(equipmentIds) {
      return new Promise((resolve) => {
        if (equipmentIds.length === 1) {
          this.screenUserApi.getUsers(equipmentIds[0]).then(res => {
            if (res.Code == 0) {
              resolve(res.Data || []);
            } else {
              resolve([]);
            }
          });
        } else {
          // 多个设备，获取所有用户后去重
          // 这里简化处理，返回空数组
          resolve([]);
        }
      });
    },

    // 处理用户选择确认
    handleUserSelect(selectedUsers, mode) {
      if (selectedUsers.length === 0) {
        this.$message.warning("请选择用户");
        return;
      }
      const equipmentIds = this.selData.map(item => item.EquipmentId);

      if (mode === "add") {
        // 批量添加
        this.screenUserApi.addUsers({
          EquipmentIds: equipmentIds,
          UserIds: selectedUsers.map(u => u.UserId)
        }).then(res => {
          if (res.Code == 0) {
            this.$message.success("添加成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      } else {
        // 批量删除
        this.screenUserApi.removeUsers({
          EquipmentIds: equipmentIds,
          UserIds: selectedUsers.map(u => u.UserId)
        }).then(res => {
          if (res.Code == 0) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      }
    },

    reload() {
      this.$refs.list.getData({ IdChain: null });
      this.loadEquipmentWithUsers();
    }
  },
};
</script>
<style lang="scss" scoped>
.el-divider {
  margin: 0 10px;
  background-color: transparent;
}
.right-box {
  width: 100%;
}
</style>
